export const ownerDocument = (node?: Node): Document =>
  (node && node.ownerDocument) || document;
